import { inject, Injectable } from '@angular/core';
import { PaymentMethod } from '../../models/paymentMethod';
import { DbService } from '../db/db.service';
import { environment } from '../../../environments/environment';
import { User } from '../../models/user';
import firebase from "firebase/compat/app";
import { CreditCardType } from '../../enums/creditCardType.enum';

@Injectable({
	providedIn: 'root'
})
export class PaymentService {

	private readonly db = inject(DbService);

	private getUserPaymentMethodRef(userId: string): firebase.firestore.CollectionReference<firebase.firestore.DocumentData> {
		return this.db.getProyIdRef(environment.projectId)
			.collection(User.PATH)
			.doc(userId)
			.collection(PaymentMethod.PATH);
	}

	async getPaymentMethodsByUserId(userId: string): Promise<PaymentMethod[]> {
		if (!userId) {
			return null;
		}

		const result = await this.getUserPaymentMethodRef(userId)
			.where('is_deleted', '==', false)
			.get();

		return result.docs.filter(payment => payment.exists).map(payment => new PaymentMethod(payment.data()));
	}

	async delete(userId: string, paymentMethodId: string): Promise<void> {
		if (!paymentMethodId || !userId) {
			return;
		}

		await this.getUserPaymentMethodRef(userId)
			.doc(paymentMethodId)
			.set({ is_deleted: true, deleted_at: firebase.firestore.FieldValue.serverTimestamp(), deleted_by: userId }, { merge: true });
	}

	getAvailableCreditCards(): CreditCardType[] {
		return [CreditCardType.VISA, CreditCardType.MASTERCARD, CreditCardType.AMEX, CreditCardType.DISCOVER];
	}

	async save(model: PaymentMethod, userId: string): Promise<void> {
		if (!model || !userId) {
			return;
		}
		if (!model?.id) {
			model.id = this.db.generateFirebaseUniqueId();
		}

		const json = model.toJson();
		await this.getUserPaymentMethodRef(userId).doc(model?.id).set(json, { merge: true });
	}

	async get(paymentMethodId: string, userId: string): Promise<PaymentMethod> {
		if (!paymentMethodId || !userId) {
			return null;
		}

		const res = await this.getUserPaymentMethodRef(userId).doc(paymentMethodId).get();
		if (!res.exists) {
			return null;
		}

		return new PaymentMethod(res.data());
	}

}
